<template>
  <Dialog :modelValue="props.modelValue" @update:modelValue="updateModelValue" type="common" :showClose="false">
    <div class="act-time-dialog" :class="cssType">
      <div class="dialog-title">
        {{ $t('payment.tip') }}
      </div>
      <div class="dialog-content">
        <div>
          {{ $t('accum.actEnded') }}
        </div>
      </div>
    </div>
  </Dialog>
</template>

<script setup>
import Dialog from '../../Popup/index.vue'
import { isMobile } from '@/utils'
import { defineProps, defineEmits } from 'vue'
const cssType = isMobile ? 'mobile' : 'pc'
const emit = defineEmits(['update:modelValue'])
const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  }
})

const updateModelValue = (value) => {
  emit('update:modelValue', value)
}

</script>

<style lang="less" scoped src="./pc_style.less"></style>
<style lang="less" scoped src="./mobile_style.less"></style>
